import { render } from "./popup_reserve.vue?vue&type=template&id=2cb26b20"
import script from "./popup_reserve.vue?vue&type=script&lang=js"
export * from "./popup_reserve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__